module.exports = __webpack_public_path__ + "img/64.2.TN.711fc032.png";